import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';
import axios from 'axios';
import Header from '../components/Header';
import { Button } from '../components/ui/button';
import { formatApiErrorDetail } from '../utils/apiError';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL;

export default function VerifyEmailPage() {
    const { syncCustomerFromApi } = useAuth();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [status, setStatus] = useState('loading'); // loading | ok | error
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage('Λείπει ο σύνδεσμος επιβεβαίωσης. Ανοίξτε το link από το email σας.');
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const res = await axios.get(`${API_URL}/storefront/auth/verify-email`, {
                    params: { token },
                });
                if (cancelled) return;
                setStatus('ok');
                setMessage(res.data?.message || 'Το email επιβεβαιώθηκε.');
                await syncCustomerFromApi();
            } catch (err) {
                if (cancelled) return;
                setStatus('error');
                setMessage(formatApiErrorDetail(err.response?.data?.detail, 'Η επιβεβαίωση απέτυχε.'));
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [token, syncCustomerFromApi]);

    return (
        <div className="min-h-screen bg-background flex flex-col">
            <Header />
            <main className="flex-1 flex items-center justify-center px-4 py-12">
                <div className="w-full max-w-md text-center space-y-6">
                    {status === 'loading' && (
                        <>
                            <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto" />
                            <p className="text-muted-foreground">Επιβεβαίωση email...</p>
                        </>
                    )}
                    {status === 'ok' && (
                        <>
                            <CheckCircle2 className="w-14 h-14 text-green-600 mx-auto" />
                            <h1 className="font-display text-xl font-semibold text-primary">Έτοιμο</h1>
                            <p className="text-muted-foreground">{message}</p>
                            <Link to="/account">
                                <Button className="rounded-full">Οι παραγγελίες μου</Button>
                            </Link>
                        </>
                    )}
                    {status === 'error' && (
                        <>
                            <XCircle className="w-14 h-14 text-destructive mx-auto" />
                            <h1 className="font-display text-xl font-semibold text-primary">Δεν ήταν δυνατή η επιβεβαίωση</h1>
                            <p className="text-muted-foreground">{message}</p>
                            <div className="flex flex-col sm:flex-row gap-3 justify-center">
                                <Link to="/account">
                                    <Button variant="outline" className="rounded-full w-full sm:w-auto">
                                        Λογαριασμός
                                    </Button>
                                </Link>
                                <Link to="/">
                                    <Button className="rounded-full w-full sm:w-auto">Κατάστημα</Button>
                                </Link>
                            </div>
                        </>
                    )}
                </div>
            </main>
        </div>
    );
}
